// src/pages/nascar/CupPractice.jsx
import React from "react";
import NascarPracticePage from "../../components/NascarPracticePage";

export default function CupPractice() {
  const BASE = import.meta?.env?.BASE_URL ?? "/";

  return (
    <NascarPracticePage
      title="Cup Practice Data"
      summarySrc={`${BASE}data/nascar/cup/latest/practice_cons.json`}
      lapsSrc={`${BASE}data/nascar/cup/latest/practice_laps.json`}
      showSources={false}
    />
  );
}
